<template>
    <div class="wrapper">
        <div class="contentBox">
            <button v-if="showLeftMenu"
                    type="button"
                    class="mobile-menu-button"
                    :class="{'is-open': mobileMenuOpen}"
                    :aria-label="$t(mobileMenuOpen ? 'menu.closeNavigation' : 'menu.openNavigation')"
                    :title="$t(mobileMenuOpen ? 'menu.closeNavigation' : 'menu.openNavigation')"
                    @click="toggleMobileMenu">
                <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
            </button>
            <div v-if="showLeftMenu && mobileMenuOpen"
                 class="mobile-menu-overlay"
                 aria-hidden="true"
                 @click="closeMobileMenu"></div>
            <leftMenu v-if="showLeftMenu"
                      class="mobile-navigation"
                      :class="{'mobile-menu-open': mobileMenuOpen}"
                      @navigate="closeMobileMenu"></leftMenu>
            <router-view :key="$route.path"></router-view>
        </div>
    </div>
</template>

<script>
    import leftMenu from './leftMenu.vue'

    export default {
        name: "home",
        components: {
            leftMenu
        },
        data() {
            return {
                mobileMenuOpen: false
            }
        },
        computed: {
            showLeftMenu() {
                return !['/invoiceCreate', '/invoiceUpdate', '/createEstimate', '/updateEstimate'].includes(this.$route.path);
            }
        },
        watch: {
            '$route.path'() {
                this.closeMobileMenu();
            }
        },
        methods: {
            toggleMobileMenu() {
                this.mobileMenuOpen = !this.mobileMenuOpen;
            },
            closeMobileMenu() {
                this.mobileMenuOpen = false;
            },
            handleEscape(event) {
                if (event.key === 'Escape') {
                    this.closeMobileMenu();
                }
            }
        },
        mounted() {
            window.addEventListener('keydown', this.handleEscape);
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.handleEscape);
        }
    }
</script>

<style scoped>
    /* 框架定位等 */
    .contentBox {
        width: 100%;
        display: flex;
        height: 100%;
        position: absolute;
    }

    .contentBox > .el-container {
        flex: 1;
        height: 100%;
        min-width: 0;
        min-height: 0;
        overflow-y: auto;
        overscroll-behavior-y: contain;
    }

    .contentBox > main,
    .contentBox > .invoice-design-page {
        flex: 1;
        height: 100%;
        min-width: 0;
        min-height: 0;
        box-sizing: border-box;
        overflow-y: auto;
        overscroll-behavior-y: contain;
    }

    .mobile-menu-button,
    .mobile-menu-overlay {
        display: none;
    }

    @media (max-width: 900px) {
        .contentBox {
            inset: 0;
            display: block;
            overflow: hidden;
        }

        .contentBox > .el-container {
            width: 100%;
            height: 100%;
        }

        .mobile-navigation {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 1002;
            width: min(240px, calc(100vw - 56px));
            min-width: 0;
            transform: translateX(-105%);
            transition: transform 180ms ease;
        }

        .mobile-navigation.mobile-menu-open {
            transform: translateX(0);
        }

        .mobile-menu-button {
            position: fixed;
            top: 14px;
            right: 14px;
            z-index: 1003;
            width: 44px;
            height: 44px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            border: 1px solid rgba(19, 38, 77, 0.1);
            border-radius: 12px;
            color: #13264d;
            background: rgba(255, 255, 255, 0.96);
            box-shadow: 0 8px 24px rgba(17, 37, 76, 0.16);
            cursor: pointer;
            font-size: 22px;
        }

        .mobile-menu-button.is-open {
            color: #ffffff;
            background: rgba(19, 38, 77, 0.86);
            border-color: rgba(255, 255, 255, 0.28);
        }

        .mobile-menu-overlay {
            position: fixed;
            inset: 0;
            z-index: 1001;
            display: block;
            background: rgba(8, 18, 38, 0.48);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .mobile-navigation {
            transition: none;
        }
    }
</style>
